import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { UniversalService } from '@commoncore/services/universal.service';
import { ITooltipAngularComp } from 'ag-grid-angular';
import { ITooltipParams } from 'ag-grid-community';

@Component({
  selector: 'common-image-tooltip',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './image-tooltip.component.html',
  styleUrl: './image-tooltip.component.scss'
})
export class CustomImageTooltip implements ITooltipAngularComp {
  public color = "";
  public object: any;
  public isCustomToolTipRequired: boolean = false;
  public params!: { isCustomToolTipRequired } & ITooltipParams;

  constructor(public universalService: UniversalService) {
  }

    agInit(params: { isCustomToolTipRequired } & ITooltipParams): void {
        this.params = params;
        this.object = this.params.data.FullObject;
        if(this.object.imageTranscodeUrl) {
          this.object.imageTranscodeUrl = this.object.imageTranscodeUrl.replace(/size=a/g, "size=n");
        }
    }

    thumbnailError(e){
      e.target.style.opacity = '0';
    }

    
}